<template>
    <b-card no-body>
        <FundDetailsDrawer ref="drawer_fund_details" />
        <SwitchFund :switch_fund.sync="modals.switch_fund" />
        <RenewFund :renew_fund.sync="modals.renew_fund" />
        <EarlyTerminate :early_terminate.sync="modals.early_terminate" />
        <b-card-header class="border-0 p-3 cursor-pointer" @click.prevent="$refs.drawer_fund_details.viewFundDetails()">
            <b-row align-h="between">
                <b-col cols="auto">
                    <h4 class="mb-0">{{ funder_profile.name }} {{ funder_profile.percent }}</h4>
                    <p class="text-xs text-muted">{{ funder_profile.period }}</p>
                </b-col>
                <b-col cols="auto">
                    <!-- <b-icon icon="three-dots-vertical" scale="1.5" class="cursor-pointer"></b-icon> -->
                    <el-dropdown trigger="click"  style="cursor: pointer">
                        <p class="el-dropdown-link mb-0 top-line">
                            <b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
                        </p>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="modals.switch_fund = true">Switch Fund</el-dropdown-item>
                            <el-dropdown-item @click.native="withdrawFund()">Withdraw Fund</el-dropdown-item>
                            <el-dropdown-item @click.native="modals.renew_fund = true">Renew Fund</el-dropdown-item>
                            <el-dropdown-item @click.native="modals.early_terminate = true">
                                <span class="text-danger">
                                    Early Terminate
                                </span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </b-col>
            </b-row>
        </b-card-header>
        <div class="p-3">
            <b-form-row>
                <b-col cols="5" class="border rounded p-2">
                    <div class="mb-3">
                        <p class="text-xs text-muted">Contribute Amt. (RM)</p>
                        <h5>{{ funder_profile.cont_amt | moneyFormatter }}</h5>
                    </div>
                    <div class="mb-3">
                        <p class="text-xs text-muted">UTD Profit (RM)</p>
                        <h5 class="text-success">{{ funder_profile.utd_profit | moneyFormatter }} {{ funder_profile.utd_profit_percent }}%</h5>
                    </div>
                </b-col>
                <b-col cols="7">
                    <div id="chart">
                        <apexchart type="donut" :options="chartOptions" :series="series"></apexchart>
                    </div>
                </b-col>
                <b-col cols="12">
                    <p class="text-muted text-xs my-3">Ref. No: {{ funder_profile.ref_no }} | OR No: {{ funder_profile.or_no }}</p>
                </b-col>
                <b-col cols="6">
                    <div class="mb-3">
                        <p class="text-xs text-muted">Profit (p.a)</p>
                        <h5>{{ funder_profile.profit_pa }}%</h5>
                    </div>
                    <div class="mb-3">
                        <p class="text-xs text-muted">Start Date</p>
                        <h5>{{ funder_profile.start_date }}</h5>
                    </div>
                    <div class="mb-3">
                        <p class="text-xs text-muted">Mature Date</p>
                        <h5>{{ funder_profile.mature_date }}</h5>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="mb-3">
                        <p class="text-xs text-muted">Lot per 10k</p>
                        <h5>{{ funder_profile.lot_per_10k }}%</h5>
                    </div>
                    <div class="mb-3">
                        <p class="text-xs text-muted">UTD Interest Rel. (RM)</p>
                        <h5>{{ funder_profile.utd_interest_rel }}</h5>
                    </div>
                    <div class="mb-3">
                        <p class="text-xs text-muted">Next Withdrawal</p>
                        <h5>{{ funder_profile.next_withdrawal }}</h5>
                    </div>
                </b-col>
            </b-form-row>
        </div>
    </b-card>
</template>
<script>
import { DropdownMenu, DropdownItem, Dropdown } from 'element-ui'
import VueApexCharts from 'vue-apexcharts'
import SwitchFund from '@/views/FundsMgmtInvestors/InvestorDetails/InvestorModals/SwitchFund'
import RenewFund from '@/views/FundsMgmtInvestors/InvestorDetails/InvestorModals/RenewFund'
import EarlyTerminate from '@/views/FundsMgmtInvestors/InvestorDetails/InvestorModals/EarlyTerminate'
import FundDetailsDrawer from '@/views/FundsMgmt/FundMgmtDrawers/FundDetailsDrawer'
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
    props: {
        funder_profile: Object
    },
    components: {
        SwitchFund,
        RenewFund,
        EarlyTerminate,
        FundDetailsDrawer,
        "apexchart": VueApexCharts,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
    },
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    type: 'donut',
                },
                legend: {
                    show: false
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                    }
                }]
            },
            modals: {
                switch_fund: false,
                renew_fund: false,
                early_terminate: false,
            }
        }
    },
    mounted() {
        // Calculate the balance correctly
        const balance = 100 - this.funder_profile.cont_amt_percent;

        // Set the series data
        this.series = [this.funder_profile.cont_amt_percent, balance];
    },
    methods: {
        withdrawFund() {
            swal.fire({
                title: 'Confirm Withdraw',
                text: "Are you sure you want to withdraw this fund? This change requires Credit Manager's approval.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Confirm',
            })
        }
    }
}
</script>